import { useTranslation } from 'react-i18next';

type RoleActionProps = { translation: string; icon: React.ReactNode };

export const RoleAction = ({ translation, icon }: RoleActionProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-start gap-3 rounded-lg border p-4">
      <div className="mt-0.5">{icon}</div>
      <div className="flex-1 space-y-1">
        <h3 className="text-sm font-semibold">
          {t(`member_invitation.role_actions.${translation}.title`)}
        </h3>
        <p className="text-sm text-foreground-muted">
          {t(`member_invitation.role_actions.${translation}.description`)}
        </p>
      </div>
    </div>
  );
};
